export default {
  SET_PROJECTS: function (state, payloads) {
    state.projects = payloads;
  },
};
